if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.onClickOutside = this.onClickOutside.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.elements.button.addEventListener('click', (e) => this.openSelector(e));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
  this.elements.button.setAttribute('aria-expanded', 'false');
  this.elements.panel.setAttribute('hidden', true);

  document.removeEventListener('click', this.onClickOutside);
  document.removeEventListener('touchstart', this.onClickOutside, { passive: true });
  document.removeEventListener('keydown', this.onKeyDown);
}

      onClickOutside(event) {
  if (this.elements.panel.contains(event.target) || this.elements.button.contains(event.target)) {
    return;
  }
  this.hidePanel();
}

onKeyDown(event) {
  if (event.key === 'Escape') this.hidePanel();
}

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
  event.preventDefault();

  // Special row: expand/collapse all countries
  if (event.currentTarget.dataset.action === 'toggle-all-countries') {
    this.classList.toggle('show-all-countries');
    return;
  }

  const form = this.querySelector('form');
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
}

      openSelector(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

  if (isOpen) {
    this.hidePanel();
    return;
  }

  this.elements.panel.removeAttribute('hidden');
  this.elements.button.setAttribute('aria-expanded', 'true');

  document.addEventListener('click', this.onClickOutside);
  document.addEventListener('touchstart', this.onClickOutside, { passive: true });
  document.addEventListener('keydown', this.onKeyDown);
}

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}

(() => {
  function isoToFlagEmoji(iso) {
    if (!iso || typeof iso !== 'string') return '';
    const code = iso.trim().toUpperCase();
    if (code.length !== 2) return '';
    return code.replace(/./g, ch => String.fromCodePoint(127397 + ch.charCodeAt(0)));
  }

  function renderLocalizationFlags(root = document) {
    // render flags only for ISO countries
    root.querySelectorAll('.localization-flag[data-iso]').forEach(el => {
      const iso = el.getAttribute('data-iso');
      el.textContent = isoToFlagEmoji(iso);
    });

    // IMPORTANT: do not inject anything for world icon, CSS handles it
    root.querySelectorAll('.localization-flag[data-icon="world"]').forEach(el => {
      el.textContent = '';
      el.innerHTML = '';
    });
  }

  document.addEventListener('DOMContentLoaded', () => renderLocalizationFlags());
  document.addEventListener('shopify:section:load', (e) => renderLocalizationFlags(e.target));
})();